<template>
    <div ref="slideElement" class="swiper-slide">
        <slot/>
    </div>
</template>
<script setup lang="ts">
import {inject, ref, onMounted} from "vue";
import { sliderItemInjection} from "../../types/keys";

const props = defineProps<{
	// The unique value to identify the slider item
	// Defaults to the DOM hierarchy index
	modelValue?: string | number,
}>();

const slideElement = ref(null);

const slider = inject(sliderItemInjection);

onMounted(() => {
	slider.addSlide(props.modelValue, slideElement.value)
})

</script>